module.exports = __webpack_public_path__ + "img/MTR-alt.4eb0038c.svg";